<div class="scroll-container" #contentItemsScroll>
  <ul class="p-list-group">
    <li
      *ngFor="let item of sidebarData; let index = index"
      class="sidebar-item"
    >
      <div class="order-actions" aria-label="Reorder item">
        <button
          pTooltip="Move up"
          tooltipPosition="top"
          aria-label="Move up"
          (click)="moveItem(index, -1, $event)"
          [disabled]="reordering || index === 0"
          pButton
          pRipple
          type="button"
          icon="pi pi-chevron-up"
          class="p-button-secondary order-button"
        ></button>
        <button
          pTooltip="Move down"
          tooltipPosition="top"
          aria-label="Move down"
          (click)="moveItem(index, 1, $event)"
          [disabled]="reordering || index === sidebarData.length - 1"
          pButton
          pRipple
          type="button"
          icon="pi pi-chevron-down"
          class="p-button-secondary order-button"
        ></button>
      </div>
      <div
        class="p-list-picture sidebar-item__visual"
        *ngIf="item.hasPicture && item.picture"
      >
        <img
          [src]="item?.picture"
          onerror="this.src='assets/images/profile-author.png'"
          alt=""
        />
      </div>
      <div
        class="sidebar-item__visual sidebar-item__icon"
        *ngIf="!item.hasPicture || !item.picture"
        aria-hidden="true"
      >
        <i [class]="getItemIcon(item)"></i>
      </div>
      <div class="sidebar-item__body">
        <div class="sidebar-item__content">
          <span
            class="p-list-title"
            role="button"
            tabindex="0"
            [title]="item.title"
            (click)="
              !isClip
                ? openSelectDialog(item)
                : goToTitleUrl(item.parentObject.url)
            "
            (keydown.enter)="
              !isClip
                ? openSelectDialog(item)
                : goToTitleUrl(item.parentObject.url)
            "
          >
            <h6>{{ item.title }}</h6>
          </span>
          <div class="p-list-text">
            {{ item.publishDate | date }} {{ item.subTitle }}
          </div>
        </div>
        <div class="sidebar-item__actions">
          <button
            pTooltip="Edit"
            tooltipPosition="top"
            aria-label="Edit"
            (click)="openEditDialog(item.parentObject)"
            pButton
            pRipple
            type="button"
            icon="pi pi-pencil"
            class="p-button-secondary"
          ></button>
          <button
            *ngIf="!item?.loadingIcon"
            pTooltip="Unfollow"
            tooltipPosition="top"
            aria-label="Unfollow"
            (click)="handleUnfollow(item.parentObject)"
            pButton
            pRipple
            type="button"
            icon="pi pi-star-fill"
            class="p-button-secondary"
          ></button>
          <button
            *ngIf="item.loadingIcon"
            pTooltip="loading"
            tooltipPosition="top"
            aria-label="Unfollowing item"
            pButton
            pRipple
            type="button"
            icon="pi pi-spin pi-spinner"
            class="p-button-secondary"
          ></button>
        </div>
      </div>
    </li>
    <li *ngIf="isTopic" class="p-d-flex p-jc-start p-pt-2">
      <button
        pButton
        type="button"
        icon="pi pi-plus"
        class="p-button-text p-button-sm"
        label="New Topic"
        (click)="openNewTopic()"
      ></button>
    </li>
    <!--
    <li *ngIf="isClip" class="p-d-flex p-jc-start p-pt-2">
      <button
        pButton
        type="button"
        icon="pi pi-plus"
        class="p-button-text p-button-sm"
        label="New Content Item"
        (click)="openNewContentItem()"
      ></button>
    </li>
    -->
  </ul>
</div>
